export default $wire => ({
    init() {
        $wire.updateCounters();
    },
});
